import { SubjectStatus } from './subject-status';
export class ClientStatus extends SubjectStatus {
}
//# sourceMappingURL=client-status.js.map